import { css } from '@emotion/react';
import { IonButton, IonCard, IonCardContent, IonContent, IonPage, IonText } from '@ionic/react';
import React from 'react';
import PageHeader from '../../components/PageHeader';
import * as commonCss from '../../styles/common';

export const NetworkNotFoundPage: React.FC = () => {
  const networkNotFoundCss = {
    card: [css({ maxWidth: 400, marginLeft: 'auto', marginRight: 'auto', marginTop: '2rem' })],
  };

  return (
    <IonPage>
      <PageHeader title="Network Not Found" />
      <IonContent css={commonCss.centered}>
        <IonCard color="danger" css={networkNotFoundCss.card}>
          <IonCardContent>
            <IonText>The network that you are looking for does not exist.</IonText>
            <br />
            <br />
            <IonButton routerLink="/networks">Select a Network</IonButton>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default NetworkNotFoundPage;
